module.exports = __webpack_public_path__ + "img/capa2.5b24ca77.webp";